/**
 * Ce que le lecteur d'écran dit d'un `<CountdownButton>` pendant son compte : il va se presser seul.
 * La barre ne se voit pas à l'oreille ; sans cette phrase, la suite arrivait sans prévenir.
 */
export function countdownHint(durationMs: number): string {
    const seconds = Math.max(1, Math.round(durationMs / 1000))
    return `Se lance tout seul dans ${seconds} seconde${seconds > 1 ? "s" : ""}.`
}
